import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    cursor: 'pointer',
    border: `2px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      borderColor: theme.palette.primary.light,
    },
  },
  cardSelected: {
    borderColor: theme.palette.primary.main,
    boxShadow: theme.shadows[3],
  },
  cardDisabled: {
    cursor: 'default',
  },
  cover: {
    width: '100%',
    height: 150,
    objectFit: 'cover',
    display: 'block',
  },
  fallbackCover: {
    width: '100%',
    height: 150,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
  },
  fallbackTitle: {
    color: theme.palette.white,
    textAlign: 'center',
    fontWeight: 700,
  },
  footer: {
    padding: theme.spacing(1.5),
  },
  title: {
    fontWeight: 600,
  },
}))

export default useStyles
